import { getCookie, setCookie } from './_utilities.js';
// used to manage the display of disclosure CTA at top of page)

// Module startup
const init = () => {
    const disclosure = document.querySelector('.disclosure-container');
    if (getCookie('noDisclaimer') === 'true' && disclosure) {
        disclosure.remove();
    }

    const closeDisclaimerButton = document.querySelector('.disclosure-close');
    if (closeDisclaimerButton) {
        closeDisclaimerButton.addEventListener('click', () => {
            document.querySelector('.disclosure-container').remove();
            setCookie('noDisclaimer', 'true', '30');
        });
    }
};

export { init };
